export default {
  'Denny - Lockdown Easter Champs': {
    plannedBy: 'Jon Cross',
    penalty: 30,
    showSolution: true,
    legs: [
      {
        imageLocation: '/denny/Leg1.jpg',
        startLocation: [143, 381],
        finishLocation: [153, 80],
        compulsoryPoints: [],
        disallowedPoints: [
          { location: [76, 300], size: 12 },
          { location: [94, 243], size: 12 },
        ],
        correctPath: [
          [155, 324],
          [168, 291],
          [141, 244],
          [141, 200],
          [155, 147],
          [154, 79],
        ],
      },
      {
        imageLocation: '/denny/Leg2.jpg',
        startLocation: [158, 231],
        finishLocation: [168, 94],
        compulsoryPoints: [{ location: [151, 153], size: 12 }],
        disallowedPoints: [],
        correctPath: [
          [121, 163],
          [182, 141],
          [169, 93],
        ],
      },
      {
        imageLocation: '/denny/Leg3.jpg',
        startLocation: [179, 235],
        finishLocation: [170, 113],
        compulsoryPoints: [{ location: [207, 207], size: 12 }],
        disallowedPoints: [],
        correctPath: [
          [211, 231],
          [195, 105],
          [170, 110],
        ],
      },
      {
        imageLocation: '/denny/Leg4.jpg',
        startLocation: [198, 383],
        finishLocation: [195, 91],
        compulsoryPoints: [
          { location: [212, 258], size: 12 },
          { location: [242, 349], size: 12 },
        ],
        disallowedPoints: [],
        correctPath: [
          [260, 331],
          [160, 182],
          [182, 166],
          [194, 91],
        ],
      },
      {
        imageLocation: '/denny/Leg5.jpg',
        startLocation: [187, 241],
        finishLocation: [165, 100],
        compulsoryPoints: [
          { location: [196, 200], size: 12 },
          { location: [201, 151], size: 12 },
        ],
        disallowedPoints: [],
        correctPath: [
          [169, 226],
          [218, 173],
          [220, 166],
          [178, 136],
          [143, 125],
          [165, 99],
        ],
      },
      {
        imageLocation: '/denny/Leg9.jpg',
        startLocation: [217, 448],
        finishLocation: [196, 83],
        compulsoryPoints: [
          { location: [207, 391.5], size: 14 },
          { location: [147, 359.5], size: 14 },
          { location: [220, 90.5], size: 14 },
          { location: [187, 210.5], size: 14 },
        ],
        disallowedPoints: [],
        correctPath: [
          [220, 397.5],
          [136, 355.5],
          [227, 92.5],
          [198, 82.5],
        ],
      },
      {
        imageLocation: '/denny/Leg10.jpg',
        startLocation: [229, 385],
        finishLocation: [215, 119],
        compulsoryPoints: [{ location: [287, 145], size: 12 }],
        disallowedPoints: [],
        correctPath: [
          [250, 285],
          [306, 164],
          [260, 118],
          [252, 126],
          [216, 120],
        ],
      },
      {
        imageLocation: '/denny/Leg11.jpg',
        startLocation: [156, 517],
        finishLocation: [220, 106],
        compulsoryPoints: [
          { location: [231, 253], size: 12 },
          { location: [114, 460], size: 12 },
        ],
        disallowedPoints: [],
        correctPath: [
          [133, 514],
          [116, 476],
          [120, 407],
          [232, 266],
          [234, 203],
          [225, 102],
        ],
      },
      {
        imageLocation: '/denny/Leg12.jpg',
        startLocation: [279, 435],
        finishLocation: [196, 132],
        compulsoryPoints: [
          { location: [249, 261], size: 12 },
          { location: [260, 240], size: 12 },
          { location: [239, 278], size: 12 },
        ],
        disallowedPoints: [],
        correctPath: [
          [265, 417],
          [236, 295],
          [266, 219],
          [225, 151],
          [198, 130],
        ],
      },
      {
        imageLocation: '/denny/Leg13.jpg',
        startLocation: [185.5, 458.5],
        finishLocation: [179.5, 71.5],
        compulsoryPoints: [
          { location: [122.5, 159], size: 14 },
          { location: [140.5, 193], size: 14 },
        ],
        disallowedPoints: [
          { location: [215.5, 394], size: 14 },
          { location: [72.5, 319], size: 14 },
          { location: [224.5, 330], size: 14 },
          { location: [218.5, 266], size: 14 },
          { location: [228.5, 220], size: 14 },
          { location: [178.5, 167], size: 14 },
        ],
        correctPath: [
          [203.5, 424],
          [193.5, 402],
          [167.5, 385],
          [191.5, 311],
          [125.5, 250],
          [155.5, 199],
          [111.5, 171],
          [180.5, 69],
        ],
      },
      {
        imageLocation: '/denny/Leg14.jpg',
        startLocation: [251, 462],
        finishLocation: [289, 114],
        compulsoryPoints: [{ location: [223, 408], size: 12 }],
        disallowedPoints: [
          { location: [205, 281], size: 12 },
          { location: [196, 285], size: 12 },
          { location: [281, 391], size: 12 },
          { location: [286, 389], size: 12 },
          { location: [283, 361], size: 12 },
        ],
        correctPath: [
          [210, 383],
          [236, 300],
          [277, 251],
          [300, 183],
          [270, 132],
          [289, 114],
        ],
      },
      {
        imageLocation: '/denny/Leg15.jpg',
        startLocation: [208, 470.5],
        finishLocation: [196.5, 84],
        compulsoryPoints: [],
        disallowedPoints: [
          { location: [285.5, 328], size: 14 },
          { location: [317.5, 349], size: 14 },
          { location: [352.5, 329], size: 14 },
          { location: [208.5, 226], size: 14 },
          { location: [188.5, 187], size: 14 },
          { location: [229.5, 160], size: 14 },
          { location: [250.5, 200], size: 14 },
          { location: [316.5, 203], size: 14 },
          { location: [312.5, 215], size: 14 },
          { location: [179.5, 443], size: 14 },
          { location: [164.5, 413], size: 14 },
          { location: [134.5, 359], size: 14 },
          { location: [145.5, 378], size: 14 },
          { location: [109.5, 217], size: 14 },
          { location: [72.5, 170], size: 14 },
          { location: [52.5, 142], size: 14 },
          { location: [115.5, 252], size: 14 },
        ],
        correctPath: [
          [218.5, 457],
          [154.5, 316],
          [164.5, 286],
          [152.5, 224],
          [146.5, 117],
          [197.5, 84],
        ],
      },
      {
        imageLocation: '/denny/Leg16.jpg',
        startLocation: [312, 361],
        finishLocation: [248, 59],
        compulsoryPoints: [],
        disallowedPoints: [
          { location: [160, 149], size: 12 },
          { location: [336, 83], size: 12 },
        ],
        correctPath: [
          [278, 272],
          [245, 233],
          [202, 214],
          [182, 160],
          [225, 138],
          [197, 76],
          [245, 55],
        ],
      },
      {
        imageLocation: '/denny/Leg17.jpg',
        startLocation: [176, 437],
        finishLocation: [190, 87],
        compulsoryPoints: [
          { location: [169, 285], size: 12 },
          { location: [188, 197], size: 12 },
        ],
        disallowedPoints: [],
        correctPath: [
          [158, 200],
          [208, 191],
          [201, 102],
          [191, 84],
        ],
      },
      {
        imageLocation: '/denny/Leg18.jpg',
        startLocation: [111, 398],
        finishLocation: [140, 72],
        compulsoryPoints: [{ location: [105, 99], size: 12 }],
        disallowedPoints: [
          { location: [41, 347], size: 12 },
          { location: [31, 286], size: 12 },
          { location: [173, 153], size: 12 },
        ],
        correctPath: [
          [159, 287],
          [116, 215],
          [152, 170],
          [99, 108],
          [139, 67],
        ],
      },
      {
        imageLocation: '/denny/Leg19.jpg',
        startLocation: [278, 314],
        finishLocation: [310, 112],
        compulsoryPoints: [
          { location: [142, 225], size: 12 },
          { location: [126, 110], size: 12 },
        ],
        disallowedPoints: [],
        correctPath: [
          [143, 248],
          [139, 189],
          [133, 186],
          [124, 88],
          [260, 83],
          [296, 111],
          [305, 111],
        ],
      },
      {
        imageLocation: '/denny/Leg20.jpg',
        startLocation: [203, 466],
        finishLocation: [299, 144],
        compulsoryPoints: [],
        disallowedPoints: [
          { location: [226, 367], size: 12 },
          { location: [206, 318], size: 12 },
          { location: [184, 179], size: 12 },
          { location: [192, 194], size: 12 },
          { location: [197, 208], size: 12 },
          { location: [201, 219], size: 12 },
          { location: [127, 321], size: 12 },
          { location: [104, 387], size: 12 },
          { location: [114, 379], size: 12 },
          { location: [126, 376], size: 12 },
        ],
        correctPath: [
          [236, 453],
          [226, 417],
          [315, 347],
          [320, 185],
          [302, 143],
        ],
      },
      {
        imageLocation: '/denny/Leg21.jpg',
        startLocation: [174, 436],
        finishLocation: [164, 75],
        compulsoryPoints: [{ location: [132, 181], size: 12 }],
        disallowedPoints: [{ location: [216, 109], size: 12 }],
        correctPath: [
          [132, 281],
          [132, 113],
          [164, 77],
        ],
      },
      {
        imageLocation: '/denny/Leg22.jpg',
        startLocation: [296, 571],
        finishLocation: [310, 108],
        compulsoryPoints: [{ location: [289, 310], size: 12 }],
        disallowedPoints: [
          { location: [347, 303], size: 12 },
          { location: [271, 359], size: 12 },
          { location: [224, 282], size: 12 },
          { location: [232, 292], size: 12 },
          { location: [240, 299], size: 12 },
          { location: [249, 310], size: 12 },
          { location: [332, 168], size: 12 },
        ],
        correctPath: [
          [222, 499],
          [327, 388],
          [311, 338],
          [273, 288],
          [313, 204],
          [277, 129],
          [309, 108],
        ],
      },
      {
        imageLocation: '/denny/Leg23.jpg',
        startLocation: [188, 388],
        finishLocation: [237, 140],
        compulsoryPoints: [
          { location: [248, 345], size: 12 },
          { location: [246, 178], size: 12 },
        ],
        disallowedPoints: [
          { location: [291, 288], size: 12 },
          { location: [227, 410], size: 12 },
        ],
        correctPath: [
          [247, 345],
          [254, 351],
          [258, 330],
          [211, 311],
          [238, 201],
          [259, 151],
          [239, 140],
        ],
      },
      {
        imageLocation: '/denny/Leg24.jpg',
        startLocation: [168, 271],
        finishLocation: [178, 137],
        compulsoryPoints: [{ location: [82, 242], size: 12 }],
        disallowedPoints: [],
        correctPath: [
          [135, 282],
          [80, 241],
          [133, 198],
          [152, 146],
          [180, 137],
        ],
      },
      {
        imageLocation: '/denny/Leg25.jpg',
        startLocation: [157, 345],
        finishLocation: [183, 95],
        compulsoryPoints: [
          { location: [167, 272], size: 12 },
          { location: [198, 169], size: 12 },
        ],
        disallowedPoints: [{ location: [167, 196], size: 12 }],
        correctPath: [
          [125, 315],
          [204, 234],
          [224, 191],
          [163, 134],
          [181, 96],
        ],
      },
    ],
  },
  Bughtlin: {
    plannedBy: 'Judy Bell',
    penalty: 30,
    timeLimit: 60,
    showSolution: true,
    legs: [
      {
        imageLocation: '/bughtlin/Bughtlin1.jpg',
        startLocation: [245, 349],
        finishLocation: [221, 107],
        compulsoryPoints: [{ location: [295, 134], size: 12 }],
        disallowedPoints: [],
        correctPath: [
          [272, 293],
          [276, 253],
          [330, 174],
          [323, 134],
          [273, 133],
          [223, 107],
        ],
      },
      {
        imageLocation: '/bughtlin/Bughtlin2.jpg',
        startLocation: [325.5, 481.5],
        finishLocation: [332.5, 70.5],
        compulsoryPoints: [
          { location: [249, 429], size: 15 },
          { location: [138, 238], size: 15 },
        ],
        disallowedPoints: [{ location: [328, 389], size: 15 }],
        correctPath: [
          [326, 450],
          [308, 444],
          [247, 429],
          [205, 404],
          [193, 384],
          [182, 320],
          [160, 290],
          [134, 204],
          [120, 168],
          [165, 152],
          [236, 111],
          [306, 77],
          [326, 69],
        ],
      },
      {
        imageLocation: '/bughtlin/Bughtlin3.jpg',
        startLocation: [166, 266],
        finishLocation: [192, 71],
        compulsoryPoints: [
          { location: [177, 165], size: 12 },
          { location: [167, 238], size: 12 },
        ],
        disallowedPoints: [],
        correctPath: [
          [165, 243],
          [189, 205],
          [171, 174],
          [189, 146],
          [193, 71],
        ],
      },
      {
        imageLocation: '/bughtlin/Bughtlin4.jpg',
        startLocation: [138, 487],
        finishLocation: [192, 226],
        compulsoryPoints: [
          { location: [241, 351], size: 12 },
          { location: [237, 286], size: 12 },
        ],
        disallowedPoints: [],
        correctPath: [
          [241, 390],
          [241, 325],
          [236, 264],
          [227, 246],
          [192, 227],
        ],
      },
      {
        imageLocation: '/bughtlin/Bughtlin5.jpg',
        startLocation: [105.5, 564],
        finishLocation: [209.5, 102],
        compulsoryPoints: [
          { location: [85, 534], size: 12 },
          { location: [198, 137], size: 12 },
        ],
        disallowedPoints: [
          { location: [184, 461], size: 12 },
          { location: [262, 323], size: 12 },
          { location: [278, 245], size: 12 },
          { location: [280, 229], size: 12 },
        ],
        correctPath: [
          [73, 516],
          [115, 463],
          [121, 450],
          [100, 424],
          [105, 398],
          [148, 331],
          [130, 284],
          [145, 264],
          [146, 247],
          [170, 207],
          [200, 171],
          [194, 142],
          [211, 103],
        ],
      },
      {
        imageLocation: '/bughtlin/Bughtlin6.jpg',
        startLocation: [138, 425],
        finishLocation: [216, 155],
        compulsoryPoints: [
          { location: [167, 167], size: 12 },
          { location: [97, 297], size: 12 },
        ],
        disallowedPoints: [],
        correctPath: [
          [141, 372],
          [75, 329],
          [87, 298],
          [112, 300],
          [135, 266],
          [141, 217],
          [156, 164],
          [187, 171],
          [215, 156],
        ],
      },
      {
        imageLocation: '/bughtlin/Bughtlin7.jpg',
        startLocation: [144, 349],
        finishLocation: [185, 95],
        compulsoryPoints: [
          { location: [249, 255], size: 12 },
          { location: [236, 171], size: 12 },
        ],
        disallowedPoints: [{ location: [77, 266], size: 12 }],
        correctPath: [
          [152, 305],
          [254, 307],
          [278, 290],
          [224, 230],
          [212, 215],
          [246, 197],
          [206, 110],
          [194, 113],
          [190, 95],
        ],
      },
      {
        imageLocation: '/bughtlin/Bughtlin8.jpg',
        startLocation: [150, 543],
        finishLocation: [167, 61],
        compulsoryPoints: [
          { location: [177, 358], size: 12 },
          { location: [114, 476], size: 12 },
          { location: [119, 432], size: 12 },
          { location: [178, 94], size: 12 },
        ],
        disallowedPoints: [],
        correctPath: [
          [131, 528],
          [144, 515],
          [94, 455],
          [147, 412],
          [148, 387],
          [182, 352],
          [188, 327],
          [165, 301],
          [179, 280],
          [172, 237],
          [199, 218],
          [198, 187],
          [186, 149],
          [184, 119],
          [168, 60],
        ],
      },
    ],
  },
}
